import { Link } from "react-router-dom";
import { SiteHeader, SiteFooter } from "../components/SiteLayout";
import { LEGAL } from "../lib/legal";
import SEO from "../components/SEO";

export default function AvisoLegal() {
  return (
    <div className="min-h-screen bg-stone-50">
      <SEO title="Aviso Legal" description="Datos identificativos del titular del sitio web fmsubastas.com conforme a la Ley 34/2002 (LSSI-CE)." path="/aviso-legal" />
      <SiteHeader />
      <article className="max-w-3xl mx-auto px-6 py-14 prose-fm">
        <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#E0651F] mb-3">Legal</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight text-[#2d1f1a] mb-8">Aviso Legal</h1>

        <p className="text-stone-600 leading-relaxed mb-8">En cumplimiento de lo dispuesto en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (<strong>LSSI-CE</strong>) y demás normativa aplicable, se informa a los usuarios de los siguientes datos identificativos del titular de este sitio web.</p>

        <H2>1. Datos identificativos del titular</H2>
        <Table rows={[
          ["Titular", LEGAL.ownerName],
          ["Forma jurídica", LEGAL.legalForm],
          ["NIF", LEGAL.taxId],
          ["Domicilio profesional", LEGAL.address],
          ["Correo electrónico", LEGAL.email],
          ["Sitio web", LEGAL.websiteUrl],
          ["Nombre comercial", LEGAL.tradename],
        ]} />

        <H2>2. Objeto del sitio web</H2>
        <P>El sitio web <strong>{LEGAL.domain}</strong> tiene como finalidad ofrecer información sobre los servicios profesionales prestados por {LEGAL.ownerName} bajo la marca comercial <em>{LEGAL.tradename}</em>: orientación, consultoría de cargas y deudas registrales, informes premium y gestión integral post-subasta en el ámbito de las subastas públicas inmobiliarias en España.</P>

        <H2>3. Condiciones de uso</H2>
        <P>El acceso y uso del sitio web atribuye al visitante la condición de Usuario, e implica la aceptación plena y sin reservas de las disposiciones contenidas en este Aviso Legal y en la Política de Privacidad. El Usuario se compromete a hacer un uso adecuado y lícito de los contenidos y servicios del sitio web, absteniéndose de utilizarlos con fines fraudulentos, ilícitos, ofensivos o que puedan perjudicar a terceros.</P>

        <H2>4. Propiedad intelectual e industrial</H2>
        <P>Todos los contenidos del sitio web (textos, imágenes, logotipos, diseños, código fuente, bases de datos, estructura y demás elementos) son propiedad exclusiva del titular o de terceros que han autorizado su uso. Queda prohibida su reproducción, distribución, comunicación pública, transformación o cualquier otra modalidad de explotación, total o parcial, sin la autorización expresa y por escrito del titular. La marca "FM Subastas & Investment" y demás signos distintivos están protegidos por la legislación vigente.</P>

        <H2>5. Limitación de responsabilidad</H2>
        <P>Los informes, consultorías y servicios prestados a través de este sitio se elaboran con la máxima diligencia profesional y la información disponible en el momento de la prestación. No obstante, el titular no garantiza el éxito en la adjudicación de subastas, la rentabilidad de las operaciones ni la ausencia de contingencias derivadas de informaciones registrales o procesales no accesibles al momento del análisis. El Usuario asume su decisión de pujar o no en cualquier subasta bajo su exclusiva responsabilidad.</P>
        <P>El titular no se responsabiliza de los daños y perjuicios derivados de interrupciones, virus informáticos, averías telefónicas, desconexiones, retrasos o bloqueos causados por deficiencias en líneas y redes electrónicas o por cualquier otra causa ajena a su control.</P>

        <H2>6. Enlaces a sitios de terceros</H2>
        <P>El sitio puede contener enlaces a sitios web de terceros (Stripe, Calendly, redes sociales, etc.). El titular no se hace responsable del contenido, políticas o prácticas de privacidad de dichos sitios externos.</P>

        <H2>7. Ley aplicable y jurisdicción</H2>
        <P>Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier conflicto, las partes se someten a los Juzgados y Tribunales del domicilio del titular ({LEGAL.address.split(",").slice(-3, -1).join(", ")}), salvo que sea aplicable un fuero imperativo distinto.</P>

        <H2>8. Modificaciones</H2>
        <P>El titular se reserva el derecho de efectuar, sin previo aviso, las modificaciones que considere oportunas en su sitio web, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que presta como la forma en la que éstos aparezcan presentados o localizados.</P>

        <p className="text-xs text-stone-500 mt-12">Última actualización: {LEGAL.lastUpdated}</p>
      </article>
      <SiteFooter />
      <ProseStyle />
    </div>
  );
}

function H2({ children }) { return <h2 className="font-display text-2xl font-black tracking-tight text-[#2d1f1a] mt-12 mb-4">{children}</h2>; }
function P({ children }) { return <p className="text-stone-700 leading-relaxed mb-4">{children}</p>; }
function Table({ rows }) {
  return (
    <div className="bg-white border border-stone-200 rounded-sm overflow-hidden my-6">
      <table className="w-full text-sm">
        <tbody>
          {rows.map(([k, v]) => (
            <tr key={k} className="border-b border-stone-200 last:border-0">
              <td className="px-4 py-3 text-stone-500 font-bold text-[10px] uppercase tracking-[0.2em] w-1/3">{k}</td>
              <td className="px-4 py-3 text-stone-800">{v}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
function ProseStyle() {
  return <style>{`.prose-fm a{color:#E0651F;text-decoration:underline}.prose-fm a:hover{color:#2d1f1a}`}</style>;
}
